module.exports = __webpack_public_path__ + "static/img/pro1-2.0cec844.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/pro1-2.png
// module id = uIbD
// module chunks = 0